import { EGetNotificationsListActionTypes, TGetNotificationsListLoading } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const getNotificationsListLoading: () => TGetNotificationsListLoading =
  actionGenerator<EGetNotificationsListActionTypes.Loading>(EGetNotificationsListActionTypes.Loading);
